import { render, staticRenderFns } from "./Polls.vue?vue&type=template&id=71d70f6b&scoped=true"
import script from "./Polls.vue?vue&type=script&lang=js"
export * from "./Polls.vue?vue&type=script&lang=js"
import style0 from "./Polls.vue?vue&type=style&index=0&id=71d70f6b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71d70f6b",
  null
  
)

export default component.exports